import { faSpotify } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Affix,
  Avatar,
  Col,
  Progress,
  Radio,
  Row,
  Select,
  Table,
  Tag,
  Typography,
  Image as AntImage,
  Popover,
  Anchor,
  BackTop,
  Spin,
} from "antd";
import { RouteComponentProps } from "react-router";
import {
  YoutubeFilled,
  InstagramOutlined,
  SearchOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { ReactComponent as ExportIcon } from "shared/assets/images/cloud-download-black.svg";
import { ReactComponent as MosaicIconWhite } from "shared/assets/images/mosaic-icon-white.svg";
import artistProfileLogo from "shared/assets/images/artist-profile-icon.png";
import { Charts, Loader, ProgressBar } from "shared/components";
import { Trans, useTranslation } from "react-i18next";
import { ColumnsType } from "antd/lib/table";
import { useCallback, useEffect, useState } from "react";
import {
  fetchArtistByName,
  fetchArtistPositionByFilter,
  fetchArtistRankingDetail,
  fetchArtistIndividualMetricLatestRelease,
  fetchArtistReleasePolynominalTrend,
  fetchArtistTrackPolynominalTrend,
  fetchArtistTopCities,
  fetchTrackPopularityHistory,
  fetchArtistDetails,
  fetchArtistRevenueForecast,
} from "radar/Service/RadarService";
import { debounce } from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";
import { getLanguageGenre } from "shared/helpers/i18nGenre";
import "./ArtistProfile.scss";
import ExportProfile from "./export-profile/ExportProfile";
import {
  TooltipIndexExplains,
  TooltipIndividualMetricsExplains,
} from "radar/components";
import { srcToBase64 } from "shared/helpers/srcToBase64";
import SingleChart from "./individual-metric-charts/SingleChart";
import MosaicCharts from "./individual-metric-charts/MosaicCharts";
import ModalAdjustInformation from "./modal-adjust-information/ModalAdjustInformation";
import { TableRowSelection } from "antd/lib/table/interface";
import { getI18nCoutry } from "shared/helpers/i18nCountry";
import CardHeader from "shared/components/card/CardHeader";
import { ReactComponent as RocketIcon } from "shared/assets/images/rocket-icon.svg";
import { ReactComponent as FollowersIcon } from "shared/assets/images/followers-icon.svg";
import {
  faArrowDown,
  faArrowTrendUp,
  faArrowUp,
  faChevronDown,
  faEllipsis,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { moneyFormat, ptBRFormat } from "shared/helpers/BRLFormat";
import { splitArrayByChunk } from "shared/helpers/array-functions";
import { formatPercentage } from "shared/helpers/percentage-helpers";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import {
  onClickInstagram,
  onClickSpotify,
  onClickYoutube,
} from "shared/helpers/external-url-helper";
import CollapseTable from "./catalog-analysis/CollapseTable";

export const socialmediaColorsValue = [
  { color: "#FF0000", text: "Youtube" },
  { color: "#1DB954", text: "Spotify" },
  { color: "#FF38A6", text: "Instagram" },
];

const { Link } = Anchor;

export const historyTrackColors = [
  { className: "color-dark-green", color: "#146600" },
  { className: "color-red", color: "#f97066" },
  { className: "color-yellow", color: "#e4bc5c" },
  { className: "color-purlple", color: "#ec0190" },
  { className: "color-soft-green", color: "#5dd183" },
];

const getTagByTrend = (
  trend: "ascending" | "descending" | "stable",
  t: any
) => {
  const colorByTrend = {
    ascending: "green",
    descending: "red",
    stable: "yellow",
  };

  if (trend)
    return (
      <span className={`trending-tag ${colorByTrend[trend]}`}>
        {t(`pages.ArtistProfile.${trend}`)}{" "}
      </span>
    );
  return null;
};

const currencuByCountry = (country: string) =>
  country !== "BR" ? "USD" : "BRL";

const ArtistProfile: React.FC<RouteComponentProps> = (props) => {
  const { location, match, history } = props;
  const { state }: any = location;
  const { id }: any = match.params;
  let savedArtist = JSON.parse(
    localStorage.getItem("RADAR_ARTIST_PROFILE") as any
  );
  if (state?.artist) {
    localStorage.setItem("RADAR_ARTIST_PROFILE", JSON.stringify(state?.artist));
    savedArtist = state?.artist;
  }
  if (id) {
    savedArtist = { artistIdStrm: id };
  }

  const { t, i18n } = useTranslation("radar");

  const [loading, setLoading] = useState<boolean>(false);
  const [showModalAdjustInfo, setShowModalAdjustInfo] =
    useState<boolean>(false);
  const [loadingArtistList, setLoadingArtistList] = useState<boolean>(false);
  const [loadingIndividualMetrics, setLoadingIndividualMetrics] =
    useState<boolean>(false);
  const [selectedArtist, setSelectedArtist] = useState<any>(savedArtist);
  const [searchedArtists, setSearchedArtists] = useState<any>([]);
  const [artistsOptions, setArtistsOptions] = useState<any[]>([]);
  const [lastReleases, setLastReleases] = useState<any>([]);
  const [lastReleasesChunks, setLastReleasesChunks] = useState<any>([]);
  const [artistTracks, setArtistTracks] = useState<any>([]);
  const [individualMetrics, setIndividualMetrics] = useState<any>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const [tracksPopularityHistory, setTracksPopularityHistory] = useState<any>({
    categories: [],
    series: [],
  });
  const [individualMetricsCategories, setIndividualMetricsCategories] =
    useState<any>([]);
  const [rankFilter, setRankFilter] = useState<any>();
  const [selectedMetric, setSelectedMetric] =
    useState<string>("performanceIndex");
  const [filterIndividualMetrics, setFilterIndividualMetrics] =
    useState<any>("all");
  const [individualMetricData, setIndividualMetricData] = useState<any>([]);
  const [artist, setArtist] = useState<any>();
  const [artistDetail, setArtistDetail] = useState<any>();
  const [exporting, setExporting] = useState<boolean>(false);
  const [enableMosaic, setEnableMosaic] = useState<boolean>(false);
  const [anchorActive, setanchorActive] = useState<boolean>(false);
  const [artistImage, setArtistImage] = useState<string>("");
  const [selectedTrend, setSelectedTrend] = useState("releaseTrend");
  const [artistReleaseTrend, setArtistReleaseTrend] = useState<any>({});
  const [artistTrackTrend, setArtistTrackTrend] = useState<any>({});
  const [revenueForecast, setRevenueForecast] = useState<any>({});
  const [revenueChart, setRevenueChart] = useState<any>({
    series: [],
    categories: [],
  });
  const [loadingRevenueInfo, setLoadingRevenueInfo] = useState<boolean>(false);
  const [mostAudiencedCities, setMostAudiencedCities] = useState<any>([]);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [performanceIndexMetricsChart, setPerformanceIndexMetricsChart] =
    useState<any>({ series: [], categories: [] });
  const [audioFeatures, setAudioFeatures] = useState<any>({
    categories: [],
    series: [],
  });
  const [similarityRank, setSimilarityRank] = useState<any>([]);
  const currency = currencuByCountry(artistDetail?.country);

  const wrappGetI18nCountry = (country: string) =>
    getI18nCoutry(country, i18n, countries);

  const colunas: (type?: string) => ColumnsType<any> = (columType?: string) => [
    { title: t("pages.ArtistProfile.releaseName"), dataIndex: "name" },
    {
      title: t("pages.ArtistProfile.releaseDate"),
      dataIndex: "releaseDate",
      render: (value) => (
        <>
          {moment(value?.dateTruncated).format(
            formatByPrecision(value.precision)
          )}
        </>
      ),
    },
    {
      title: t(
        `pages.ArtistProfile.${
          columType === "release" ? "type" : "releaseType"
        }`
      ),
      dataIndex: "type",
    },
    {
      title: t("pages.ArtistProfile.releaseLabel"),
      dataIndex: "label",
    },
    {
      title: t("pages.ArtistProfile.popularity"),
      dataIndex: "popularity",
      align: "center",
      sorter: (a, b) => a.popularity - b.popularity,
    },
  ];

  const { genres } = useSelector((state: any) => state.genres);
  const { countries } = useSelector((state: any) => state.countries);

  const wrappGetI18nGenre = useCallback(
    (genre: string) => getLanguageGenre(genre, i18n.language, genres),
    [i18n.language, genres]
  );

  const getArtistRanking = useCallback(async () => {
    setLoading(true);
    const response = await fetchArtistRankingDetail(
      selectedArtist.artistIdStrm
    );
    setArtist(response);
    setLoading(false);
  }, [selectedArtist]);

  const getArtistRevenueForecast = useCallback(
    async (artistIdStrm: string, currency: string) => {
      setLoadingRevenueInfo(true);
      const response = await fetchArtistRevenueForecast(artistIdStrm, currency);
      if (response) setRevenueForecast(response);
      setLoadingRevenueInfo(false);
    },
    []
  );

  const getArtistDetails = useCallback(async () => {
    const response = await fetchArtistDetails(selectedArtist.artistIdStrm);
    setArtistDetail(response);
    const currency = currencuByCountry(response?.country);
    getArtistRevenueForecast(response?.artistIdStrm, currency);
  }, [selectedArtist, getArtistRevenueForecast]);

  const getArtistRankByFilter = useCallback(async () => {
    const response: any = await fetchArtistPositionByFilter(
      selectedArtist.artistIdStrm,
      state?.filter || { defaultFilter: true }
    );
    setRankFilter(response);
  }, [selectedArtist, state]);

  const clearProfile = () => {
    setArtistReleaseTrend({});
    setArtistTrackTrend({});
    setSimilarityRank([]);
    setAudioFeatures({
      categories: [],
      series: [],
    });
    setRevenueForecast({});
  };

  useEffect(() => {
    async function getIndividualMetrics() {
      setIndividualMetrics(undefined);
      setLastReleases([]);
      setLastReleasesChunks([]);
      setArtistTracks([]);
      setSelectedRowKeys([]);
      setSelectedTrend("releaseTrend");
      setTracksPopularityHistory({
        categories: [],
        series: [],
      });
      setLoadingIndividualMetrics(true);

      const response = await fetchArtistIndividualMetricLatestRelease(
        selectedArtist.artistIdStrm
      );
      if (response) {
        setIndividualMetrics(response.artistIndividualMetrics);
        setLastReleases(response.artistReleases);
        setLastReleasesChunks(splitArrayByChunk(response.artistReleases, 25));
        setArtistTracks(response.artistTracks);
        setSelectedRowKeys(
          response.artistTracks
            .slice(0, 5)
            .map((track: any) => track.trackIdSpotify)
        );
      }
      setLoadingIndividualMetrics(false);
    }

    async function getArtistTrend() {
      const responseTrend = await fetchArtistReleasePolynominalTrend(
        selectedArtist.artistIdStrm
      );

      if (responseTrend) {
        setArtistReleaseTrend({
          scatterData: responseTrend.data,
          lineData: responseTrend.polynomialCurve,
          firstXaxis: responseTrend.oldestReleaseMonth,
        });
      }
    }

    clearProfile();

    async function getArtistTopCities() {
      const cities = await fetchArtistTopCities(selectedArtist.artistIdStrm);
      setMostAudiencedCities(cities?.response?.slice(0, 5) ?? []);
    }

    if (selectedArtist) {
      getArtistRanking();
      getIndividualMetrics();
      getArtistTrend();
      getArtistDetails();
      getArtistTopCities();
      getArtistRankByFilter();
    }
  }, [
    selectedArtist,
    getArtistDetails,
    getArtistRankByFilter,
    getArtistRanking,
  ]);

  const onChangeArtist = (value: any) => {
    const artist = searchedArtists.find(
      (opt: any) => opt.artistIdStrm === value
    );

    localStorage.setItem("RADAR_ARTIST_PROFILE", JSON.stringify(artist));
    setSelectedArtist(artist);
  };

  const getArtists = async (artistNameTerm: string) => {
    if (artistNameTerm) {
      setLoadingArtistList(true);
      const response = await fetchArtistByName({ artistNameTerm });
      setLoadingArtistList(false);
      setSearchedArtists(response);
    }
  };

  const onChangeTrend = (value: string) => {
    setSelectedTrend(value);
  };

  const onSelectChange = (selectedKeys: any) => {
    if (selectedKeys.length > 5) {
      const selectedTracks = selectedKeys.slice(1);

      setSelectedRowKeys(selectedTracks);
    } else {
      setSelectedRowKeys(selectedKeys);
    }
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    hideSelectAll: true,
    renderCell(_, record, __, originNode) {
      const index = selectedRowKeys.indexOf(record.trackIdSpotify);
      console.log(index);
      return (
        <div className={historyTrackColors[index]?.className || ""}>
          {originNode}
        </div>
      );
    },
  };

  const formatByPrecision = (precision: string) => {
    if (precision === "day") return "DD/MM/YYYY";
    if (precision === "month") return "MM/YYYY";
    if (precision === "year") return "YYYY";
  };

  const getReleaseFrequencyData = () => {
    if (artistDetail) {
      const isUnderAverage = artist?.releaseFrequency?.isUnderAverage;
      const average = isUnderAverage
        ? t("pages.ArtistProfile.below")
        : t("pages.ArtistProfile.above");
      return {
        daysOfRelease: artist?.releaseFrequency?.daysOfRelease,
        percentageOfRelease: `${Math.abs(
          artist?.releaseFrequency?.percentageOfRelease
        )} %`,
        average: t("pages.ArtistProfile.releaseFrequencyAverage", { average }),
        isUnderAverage,
      };
    }
    return {
      daysOfRelease: "-",
      percentageOfRelease: "-",
      average: "-",
      isUnderAverage: false,
    };
  };

  const getSpotifyInfo: any = () => {
    if (artist && artist.spotify) {
      const { spotify } = artist;
      const { spotifyFirstRelease, spotifyLatestRelease } = spotify;
      const firstRelease =
        (spotifyFirstRelease &&
          moment(spotifyFirstRelease.dateTruncated).format(
            formatByPrecision(spotifyFirstRelease.precision)
          )) ||
        0;
      const latestRelease =
        (spotifyLatestRelease &&
          moment(spotifyLatestRelease.dateTruncated).format(
            formatByPrecision(spotifyLatestRelease.precision)
          )) ||
        0;

      return {
        firstRelease,
        latestRelease,
      };
    }
    return {};
  };

  const getForecastChartAnnotations = () => {
    if (revenueChart?.middleLine)
      return {
        xaxis: [
          {
            x: revenueChart?.middleLine,
            strokeDashArray: 0,
            borderColor: "#BD0173",
            borderWidth: 4,
            label: {
              borderColor: "#BD0173",
              orientation: "horizontal",
              textAnchor: "middle",
              borderRadius: 10,
              borderWidth: 1,
              style: {
                color: "#BD0173",
                background: "#BD0173",
              },
              text: "_",
            },
          },
          {
            x: revenueChart?.middleLine,
            strokeDashArray: 0,
            borderColor: "#BD0173",
            borderWidth: 4,
            label: {
              borderColor: "#BD0173",
              orientation: "horizontal",
              textAnchor: "middle",
              position: "bottom",
              borderRadius: 10,
              borderWidth: 1,
              style: {
                color: "#BD0173",
                background: "#BD0173",
              },
              text: "_",
            },
          },
        ],
      };
  };

  const onCompareClick = () => {
    if (artist?.artistMetadata) {
      const copyArtist = { ...artist.artistMetadata };
      copyArtist.imagesSpotify = artist?.spotify?.imagesSpotify;

      localStorage.setItem(
        "RADAR_ARTIST_COMPARISON",
        JSON.stringify([copyArtist])
      );
      history.push("/comparison");
    }
  };

  const prepareExport = () => {
    if (individualMetrics) {
      const categories =
        individualMetrics?.series.map((serie: any) =>
          new Date(moment(serie).toDate()).getTime()
        ) || [];
      const series = [
        {
          name: t("pages.ArtistProfile.performanceIndex"),
          data:
            individualMetrics?.data?.performanceIndex?.map(
              (data: any) => data
            ) || [],
        },
      ];

      const tooltip = {
        points:
          individualMetrics?.markers.map((serie: any) => ({
            text: serie.text,
            x: new Date(moment(serie.x).toDate()).getTime(),
            y: serie.y[selectedMetric],
          })) || [],
      };
      setPerformanceIndexMetricsChart({
        categories,
        series,
        tooltip,
      });
    }

    setExporting(true);
  };

  const { firstRelease, latestRelease } = getSpotifyInfo(
    filterIndividualMetrics
  );

  const { average, daysOfRelease, percentageOfRelease, isUnderAverage } =
    getReleaseFrequencyData();

  useEffect(() => {
    const indvidualMetrics = [];
    const categories =
      individualMetrics?.series
        ?.filter(
          (serie: any) =>
            filterIndividualMetrics === "all" ||
            moment().diff(moment(serie), "months") <
              (filterIndividualMetrics as number)
        )
        .map((serie: any) => new Date(moment(serie).toDate()).getTime()) || [];
    if (individualMetrics) {
      indvidualMetrics.push({
        name: t(`pages.ArtistProfile.${selectedMetric}`),
        data: individualMetrics?.data[selectedMetric].slice(
          individualMetrics?.series.length - categories.length
        ),
      });
    }
    setIndividualMetricData(indvidualMetrics);
    setIndividualMetricsCategories(categories);
  }, [individualMetrics, filterIndividualMetrics, selectedMetric, t]);

  const onChangeIndividualMetrics = (evt: any) => {
    setFilterIndividualMetrics(evt.target.value);
  };

  const onChangeMetric = (key: string) => {
    setSelectedMetric(key);
  };

  useEffect(() => {
    setArtistsOptions(
      searchedArtists.map(
        ({ artistIdStrm, artistName, imagesSpotify }: any) => ({
          id: artistIdStrm,
          name: artistName,
          image: (imagesSpotify && imagesSpotify[2]?.url) || "",
        })
      )
    );
  }, [searchedArtists]);

  useEffect(() => {
    async function getArtistTrackTrend() {
      if (!selectedArtist?.artistIdStrm) {
        return;
      }

      const responseTrend = await fetchArtistTrackPolynominalTrend(
        selectedArtist.artistIdStrm
      );

      if (responseTrend) {
        setArtistTrackTrend({
          scatterData: responseTrend.data,
          lineData: responseTrend.polynomialCurve,
          firstXaxis: responseTrend.oldestReleaseMonth,
        });
      }
    }
    getArtistTrackTrend();
  }, [artist, selectedArtist]);

  useEffect(() => {
    const image = artistDetail?.imageProfileUrl;
    if (image) {
      srcToBase64(image).then((dataURL) => {
        setArtistImage(dataURL);
      });
    } else {
      setArtistImage("");
    }

    const getI18nGenre = (genre: string) => {
      if (genre) {
        const genreI18n = genre.split(" ")[0];
        return `${wrappGetI18nGenre(genreI18n)} ${genre.split(" ")[1] || ""}`;
      }
      return "";
    };

    if (artist) {
      if (artist.audioFeatures) {
        const { categories, series } = artist.audioFeatures;
        setAudioFeatures({
          categories,
          series: series.slice(0, 4).map((serie: any) => ({
            name: getI18nGenre(serie.name),
            data: serie.data,
          })),
        });
      }

      if (artist.similarityRank) {
        setSimilarityRank(artist.similarityRank.slice(0, 3));
      }
    }
  }, [artist, artistDetail, wrappGetI18nGenre]);

  useEffect(() => {
    const image = artistDetail?.imageProfileUrl;
    if (image) {
      srcToBase64(image).then((dataURL) => {
        setArtistImage(dataURL);
      });
    } else {
      setArtistImage("");
    }
  }, [artistDetail]);

  useEffect(() => {
    const getTracksPopularityHistory = async () => {
      const response = await fetchTrackPopularityHistory(selectedRowKeys);
      setTracksPopularityHistory({
        categories: response.categorioes || response.categories,
        series: response.series.map((serie: any) => ({
          name: artistTracks.find(
            (track: any) => track.trackIdSpotify === serie.trackId
          )?.name,
          data: serie.data,
        })),
      });
    };

    if (selectedRowKeys.length > 0) {
      getTracksPopularityHistory();
    }
  }, [selectedRowKeys, artistTracks]);

  useEffect(() => {
    if (revenueForecast?.chart) {
      const orderSeries = [
        "royaltiesIndependente",
        "shareInIndependente",
        "shareOutIndependente",
        "royaltiesMajor",
        "shareInMajor",
        "shareOutMajor",
      ];
      const series = orderSeries.map((seriesName) => {
        const serie = revenueForecast?.chart.series.find(
          (s: any) => s.name === seriesName
        );
        return {
          ...serie,
          name: t(`pages.ArtistProfile.${serie?.name}`),
        };
      });

      setRevenueChart({
        series,
        categories:
          revenueForecast?.chart.categories?.map((item: string) =>
            moment(item).format("MM/YY")
          ) || [],
        middleLine: moment(revenueForecast?.chart.categories[12]).format(
          "MM/YY"
        ),
      });
    } else {
      setRevenueChart({
        series: [],
        categories: [],
      });
    }
  }, [revenueForecast, t]);

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Profile.S4L_ARTIST_PROFILE,
    });
  }, []);

  if (exporting)
    return (
      <ExportProfile
        artist={artist}
        artistImage={artistImage}
        performanceIndexMetricsChart={performanceIndexMetricsChart}
        releaseChunks={lastReleasesChunks}
        audioFeatures={audioFeatures}
        similarityRank={similarityRank}
        trendReleaseInfo={artistReleaseTrend}
        trendTrackInfo={artistTrackTrend}
        mostAudiencedCities={mostAudiencedCities}
        artistDetail={artistDetail}
        rankFilter={rankFilter}
        firstRelease={firstRelease}
        latestRelease={latestRelease}
        daysOfRelease={daysOfRelease}
        percentageOfRelease={percentageOfRelease}
        average={average}
        isUnderAverage={isUnderAverage}
        tracksPopularityHistory={tracksPopularityHistory}
        close={() => setExporting(false)}
      />
    );

  if (loading) return <Loader.Simple size="large" fontSize={72} />;

  if (!artist && !artistDetail)
    return (
      <div className="artist-profile" style={{ height: "100vh" }}>
        <Row>
          <Col xs={12}>
            <Typography.Title style={{ color: "white", fontSize: 24 }}>
              {t("pages.ArtistProfile.title")}
            </Typography.Title>
            <Typography.Text
              style={{
                color: "#A1A1A1",
                fontSize: 16,
                textTransform: "uppercase",
              }}
            >
              {t("pages.ArtistProfile.subTitle")}
            </Typography.Text>
          </Col>
        </Row>
        <Row justify="center" style={{ alignItems: "center", flex: 1 }}>
          <Col xs={12}>
            <div className="selecao-artista-empty">
              <img src={artistProfileLogo} alt="Imagem do artista" />
              <Select
                showSearch
                filterOption={false}
                suffixIcon={<SearchOutlined />}
                onSearch={debounce(getArtists, 1000)}
                onSelect={onChangeArtist}
                style={{ width: "100%" }}
                value={artistDetail?.artistName}
                placeholder={t("pages.ArtistProfile.selectArtistEmpty")}
                notFoundContent={
                  <Loader.NotFoundLoader loading={loadingArtistList} />
                }
              >
                {artistsOptions.map((artist: any) => (
                  <Select.Option value={artist.id} key={artist.id}>
                    {artist.image && (
                      <Avatar style={{ marginRight: 6 }} src={artist.image} />
                    )}
                    {artist.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
      </div>
    );

  return (
    <div className="artist-profile">
      <ModalAdjustInformation
        onClose={() => setShowModalAdjustInfo(false)}
        show={showModalAdjustInfo}
        artist={artist?.artistMetadata}
      />

      <Row>
        <Col xs={12}>
          <Typography.Title style={{ color: "white" }}>
            {t("pages.ArtistProfile.title")}
          </Typography.Title>
          <Typography.Text
            style={{
              color: "#A1A1A1",
              fontSize: 16,
              textTransform: "uppercase",
            }}
          >
            {t("pages.ArtistProfile.subTitle")}
          </Typography.Text>
        </Col>
      </Row>
      <Row style={{ marginTop: 24 }}>
        <Col xs={8}>
          <div className="selecao-artista">
            <Select
              showSearch
              filterOption={false}
              suffixIcon={<SearchOutlined />}
              onSearch={debounce(getArtists, 1000)}
              onSelect={onChangeArtist}
              style={{ width: "100%" }}
              value={artistDetail?.artistName}
              placeholder={t("pages.ArtistProfile.selectArtist")}
              notFoundContent={
                <Loader.NotFoundLoader loading={loadingArtistList} />
              }
            >
              {artistsOptions.map((artist: any) => (
                <Select.Option value={artist.id} key={artist.id}>
                  {artist.image && (
                    <Avatar style={{ marginRight: 6 }} src={artist.image} />
                  )}
                  {artist.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col offset={8} xs={8}>
          <Row justify="end">
            <button
              className="botao-vazado"
              style={{ marginRight: 18 }}
              onClick={onCompareClick}
            >
              {t("pages.ArtistProfile.compare")}
            </button>
            <button className="botao-branco" onClick={prepareExport}>
              {t("pages.ArtistProfile.export")}
              <ExportIcon className="download-icon" />
            </button>
          </Row>
        </Col>
      </Row>
      <Row gutter={[0, 32]} style={{ marginTop: 36 }}>
        <Col xs={24}>
          <div>
            <Row gutter={[16, 32]}>
              <Col xs={6}>
                <CardHeader
                  className="with-header"
                  header={
                    <div className="artist-info-box">
                      <AntImage
                        src={artistDetail?.imageProfileUrl}
                        style={{
                          borderRadius: "50%",
                          width: 75,
                          height: 75,
                          objectFit: "cover",
                        }}
                      />
                      <div className="name">
                        {artist?.artistMetadata?.artistName}

                        <span>
                          {wrappGetI18nCountry(
                            artist?.artistMetadata?.country
                          )?.toUpperCase()}
                        </span>
                        {/* <button className="botao-branco">
                          {t("pages.ArtistProfile.follow")}
                        </button> */}
                      </div>
                    </div>
                  }
                >
                  <div className="artist-infos">
                    <div>
                      <span className="genre">
                        {t("pages.ArtistProfile.genres")}
                      </span>
                      {artistDetail?.genresStrm?.map(
                        (genre: any, index: number) => (
                          <Tag
                            key={`GENRE_${index}_${Math.random()}`}
                            color="transparent"
                            style={{
                              border: `1px solid ${
                                index === 0 ? "#7692FF" : "#AF87FF"
                              } `,
                              color: `${index === 0 ? "#7692FF" : "#AF87FF"}`,
                              backgroundColor: `${
                                index === 0 ? "#2F60FF1A" : "#AF87FF1A"
                              }`,
                              textTransform: "capitalize",
                            }}
                          >
                            {wrappGetI18nGenre(genre)}
                          </Tag>
                        )
                      )}
                      <span className="genre" style={{ marginTop: 16 }}>
                        {t("pages.ArtistProfile.spotifyGenres")}
                      </span>
                      {artistDetail?.genresSpotify
                        ?.slice(0, 2)
                        .map((genre: any, index: number) => (
                          <Tag
                            key={`GENRE_SPOTIFY_${index}_${Math.random()}`}
                            color="transparent"
                            style={{
                              border: `1px solid ${
                                index === 0 ? "#7692FF" : "#AF87FF"
                              } `,
                              color: `${index === 0 ? "#7692FF" : "#AF87FF"}`,
                              backgroundColor: `${
                                index === 0 ? "#2F60FF1A" : "#AF87FF1A"
                              }`,
                              textTransform: "capitalize",
                            }}
                          >
                            {genre}
                          </Tag>
                        ))}
                    </div>
                    <span
                      style={{
                        width: "100%",
                        borderBottom: "1px solid #373737",
                        marginTop: 8,
                      }}
                    />

                    <div>
                      <div>
                        <span className="stage">
                          {t("pages.ArtistProfile.stage")}
                        </span>
                        <span className="stage-name">
                          {t(
                            `pages.CareerDiagnose.stage.${
                              artist?.strmIndexes?.careerStage || 0
                            }.journeyTitle`
                          )}
                        </span>
                      </div>
                      <Progress
                        strokeColor={{
                          "0%": "#E64B4B",
                          "15%": "#F3795E",
                          "35": "#E4BC5C",
                          "50": "#39D68D",
                          "70": "#37B1E4",
                          "85": "#874FC6",
                          "100": "#F05576",
                        }}
                        strokeWidth={5}
                        trailColor="#D2CCDF33"
                        percent={Math.ceil(
                          artist?.strmIndexes?.stageProgress * 100 || 0
                        )}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: 4,
                          alignItems: "center",
                          marginTop: 8,
                        }}
                      >
                        <span
                          style={{
                            color: "#6E8DFF",
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          {t("pages.ArtistProfile.ranking")}
                        </span>
                        <span
                          style={{
                            fontSize: 12,
                          }}
                        >
                          {t("pages.ArtistProfile.rankingBased")}
                        </span>

                        <span
                          style={{
                            flex: 1,
                            textAlign: "end",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowFilter(!showFilter)}
                        >
                          {t("pages.ArtistProfile.seeMore")}{" "}
                          <FontAwesomeIcon icon={faChevronDown} />
                        </span>
                      </div>
                      <div
                        className="filter"
                        style={{ display: showFilter ? "block" : "none" }}
                      >
                        <Typography.Text>
                          {t("pages.ArtistProfile.filterText")}
                        </Typography.Text>
                        <ul>
                          <li>
                            {t("pages.ArtistProfile.genreFlter")}
                            <strong>
                              {rankFilter?.filter?.genre?.join(", ") ||
                                t("pages.ArtistProfile.All")}
                            </strong>
                          </li>
                          <li>
                            {t("pages.ArtistProfile.spotifyGenreFilter")}
                            <strong>
                              {rankFilter?.filter?.genreSpotify?.join(", ")}
                            </strong>
                          </li>
                          <li>
                            {t("pages.ArtistProfile.countryFilter")}
                            <strong>
                              {rankFilter?.filter?.country?.join(", ") ||
                                t("pages.ArtistProfile.All")}
                            </strong>
                          </li>
                          <li>
                            {t("pages.ArtistProfile.stageFilter")}
                            <strong>
                              {rankFilter?.filter?.stageInit} -{" "}
                              {rankFilter?.filter?.stageEnd}
                            </strong>
                          </li>
                          <li>
                            {t(
                              "pages.ArtistProfile.daysSinceFirstReleaseFilter"
                            )}
                            <strong>
                              {(rankFilter?.filter?.daysSinceFirstRelease &&
                                t("pages.ArtistsRanking.yearsSinceRelease", {
                                  year:
                                    rankFilter?.filter?.daysSinceFirstRelease /
                                    365,
                                })) ||
                                "-"}
                            </strong>
                          </li>
                          <li>
                            {t("pages.ArtistProfile.releasesLastYearFilter")}
                            <strong>
                              {rankFilter?.filter?.releasesLastYear || "-"}
                            </strong>
                          </li>
                          <li>
                            {t(
                              "pages.ArtistProfile.growthSpeedIndexRankFilter"
                            )}
                            <strong>
                              {t("pages.ArtistProfile.rankingValueFromTo", {
                                from: rankFilter?.growthSpeedIndexRank || "N/A",
                                to: rankFilter?.artistCount || "-",
                                interpolation: { escapeValue: false },
                              })}
                            </strong>
                          </li>
                          <li>
                            {t(
                              "pages.ArtistProfile.performanceDevelopmentRatioRankFilter"
                            )}
                            <strong>
                              {t("pages.ArtistProfile.rankingValueFromTo", {
                                from:
                                  rankFilter?.performanceDevelopmentRatioRank ||
                                  "N/A",
                                to: rankFilter?.artistCount || "-",
                                interpolation: { escapeValue: false },
                              })}
                            </strong>
                          </li>
                          <li>
                            {t(
                              "pages.ArtistProfile.spotifyPerformanceDeltaRankFilter"
                            )}
                            <strong>
                              {t("pages.ArtistProfile.rankingValueFromTo", {
                                from:
                                  rankFilter?.spotifyPerformanceDeltaRank ||
                                  "N/A",
                                to: rankFilter?.artistCount || "-",
                                interpolation: { escapeValue: false },
                              })}
                            </strong>
                          </li>
                          <li>
                            {t("pages.ArtistProfile.performanceIndexRanking")}
                            <strong>
                              {t("pages.ArtistProfile.rankingValueFromTo", {
                                from: rankFilter?.performanceIndexRank || "N/A",
                                to: rankFilter?.artistCount || "-",
                                interpolation: { escapeValue: false },
                              })}
                            </strong>
                          </li>
                          <li>
                            {t("pages.ArtistProfile.volatilityRanking")}
                            <strong>
                              {t("pages.ArtistProfile.rankingValueFromTo", {
                                from: rankFilter?.volatilityIndexRank || "N/A",
                                to: rankFilter?.artistCount || "-",
                                interpolation: { escapeValue: false },
                              })}
                            </strong>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Col>
              <Col xs={5}>
                <CardHeader
                  className="with-header"
                  header={
                    <div className="general-performance">
                      <span
                        className={`weekly-change ${
                          rankFilter?.positionDif === 0
                            ? "same"
                            : rankFilter?.positionDif > 0
                            ? "up"
                            : "down"
                        }`}
                      >
                        {rankFilter?.positionDif === 0 ? (
                          <></>
                        ) : rankFilter?.positionDif > 0 ? (
                          <FontAwesomeIcon icon={faArrowUp} />
                        ) : (
                          <FontAwesomeIcon icon={faArrowDown} />
                        )}{" "}
                        {rankFilter?.positionDif > 0 ||
                        rankFilter?.positionDif < 0
                          ? Math.abs(rankFilter?.positionDif)
                          : "-"}
                      </span>
                      <span>{t("pages.ArtistProfile.weeklyChanges")}</span>
                      <span className="variation">
                        # {rankFilter?.performanceIndexRank}
                      </span>
                      <span>
                        {t("pages.ArtistProfile.generalPerformanceRanking")}
                      </span>
                    </div>
                  }
                >
                  <div style={{ padding: 16 }}>
                    <Typography.Title
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <FontAwesomeIcon
                        icon={faSpotify}
                        style={{ marginRight: 12 }}
                        color=" #44DE66"
                      />{" "}
                      {t("pages.ArtistProfile.biggestAudiences")}
                    </Typography.Title>
                    <div className="most-audienced-city">
                      <span
                        style={{
                          marginLeft: 33,
                          fontSize: 12,
                          fontWeight: 400,
                        }}
                      >
                        {t("pages.ArtistProfile.city")}
                      </span>
                      <span> {t("pages.ArtistProfile.listeners")}</span>
                    </div>
                    <div className="most-audienced-cities">
                      {mostAudiencedCities.map((item: any, index: any) => {
                        return (
                          <div
                            className="most-audienced-city"
                            key={`AUDIENCE_${item?.city}_${index}`}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <span className="item-list-circle">
                                {index + 1}
                              </span>
                              <span
                                style={{
                                  marginLeft: "15px",
                                }}
                              >
                                {item.city}
                              </span>
                            </div>

                            {`${item.listenerCount}`}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </CardHeader>
              </Col>
              <Col xs={13}>
                <CardHeader className="without-header">
                  <Row>
                    <Col xs={8}>
                      <div className="followers-card">
                        <div>
                          <h1> {t("pages.ArtistProfile.totalFollowers")}</h1>
                          <h4>
                            {" "}
                            {t(
                              "pages.ArtistProfile.followersAndSubscribersLast30Days"
                            )}
                          </h4>
                        </div>
                        <div className="chart-followers-last-week">
                          <Charts.PieChart
                            height={130}
                            width={130}
                            innerRadius={50}
                            outerRadius={60}
                            customLabel={({ cx, cy }: any) => <></>}
                            colors={socialmediaColorsValue.map(
                              ({ color }) => color
                            )}
                            series={socialmediaColorsValue.map(({ text }) => ({
                              value:
                                (artistDetail &&
                                  artistDetail[
                                    `${text.toLowerCase()}FollowersTotal`
                                  ]) ||
                                0,
                              name: text,
                            }))}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 16,
                            fontWeight: 600,
                            color: "#fff",
                          }}
                        >
                          {ptBRFormat(artistDetail?.followersTotal)}
                        </span>
                        {artistDetail?.followersTotalDifPercentage !== null && (
                          <span
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                            }}
                            className={`weekly-change ${
                              artistDetail?.followersTotalDifPercentage > 0
                                ? "up"
                                : "down"
                            }`}
                          >
                            {artistDetail?.followersTotalDifPercentage === 0 ? (
                              <></>
                            ) : artistDetail?.followersTotalDifPercentage >
                              0 ? (
                              <FontAwesomeIcon icon={faArrowUp} />
                            ) : (
                              <FontAwesomeIcon icon={faArrowDown} />
                            )}
                            {artistDetail?.followersTotalDifPercentage} %
                          </span>
                        )}
                      </div>
                      <div className="legenda">
                        {socialmediaColorsValue.map((info: any) => (
                          <div
                            className="item"
                            key={`SOCIAL_MEDIA_COLOR_${info.color}`}
                          >
                            <span className="label">
                              <span
                                className="circle"
                                style={{
                                  backgroundColor: info.color,
                                  fontWeight: 400,
                                }}
                              />
                              {info.text}
                            </span>
                          </div>
                        ))}
                      </div>
                    </Col>
                    <Col xs={16}>
                      <div style={{ padding: 16 }}>
                        <Row>
                          <Col xs={24}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                color: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faEllipsis}
                                onClick={() => setShowModalAdjustInfo(true)}
                              />
                            </div>
                            <div className="card-social">
                              <div className="artist-profile">
                                <div
                                  className="platform-icon"
                                  onClick={() =>
                                    onClickSpotify(
                                      artist?.artistMetadata?.artistIdSpotify
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faSpotify}
                                    color="#F2F2F2"
                                  />
                                  <span style={{ color: "#c8c8c8" }}>
                                    Spotify
                                  </span>
                                </div>
                                <span className="platform-number">
                                  {ptBRFormat(
                                    artistDetail?.spotifyFollowersTotal
                                  )}
                                </span>
                                {artistDetail?.spotifyFollowersDifPercentage !==
                                  null && (
                                  <span
                                    className={`weekly-change ${
                                      artistDetail?.spotifyFollowersTotal >
                                      artistDetail?.spotifyFollowersTotalPrevious
                                        ? "up"
                                        : "down"
                                    }`}
                                  >
                                    {artistDetail?.spotifyFollowersTotal >
                                    artistDetail?.spotifyFollowersTotalPrevious ? (
                                      <FontAwesomeIcon icon={faArrowUp} />
                                    ) : (
                                      <FontAwesomeIcon icon={faArrowDown} />
                                    )}{" "}
                                    {
                                      artistDetail?.spotifyFollowersDifPercentage
                                    }{" "}
                                    %
                                  </span>
                                )}
                                {artistDetail?.spotifyFollowersDifQuantity !==
                                  null && (
                                  <span className="platform-variation">
                                    {` (${
                                      artistDetail?.spotifyFollowersTotal >
                                      artistDetail?.spotifyFollowersTotalPrevious
                                        ? "+"
                                        : "-"
                                    } ${
                                      artistDetail?.spotifyFollowersDifQuantity
                                    } )`}
                                  </span>
                                )}
                              </div>

                              <div className="artist-profile">
                                <div
                                  className="platform-icon"
                                  onClick={() =>
                                    onClickInstagram(
                                      artist?.artistMetadata?.usernameInstagram
                                    )
                                  }
                                >
                                  <InstagramOutlined />
                                  <span style={{ color: "#c8c8c8" }}>
                                    Instagram
                                  </span>
                                </div>
                                <span className="platform-number">
                                  {ptBRFormat(
                                    artistDetail?.instagramFollowersTotal
                                  )}
                                </span>
                                {artistDetail?.instagramFollowersDifPercentage !==
                                  null && (
                                  <span
                                    className={`weekly-change ${
                                      artistDetail?.instagramFollowersTotal >
                                      artistDetail?.instagramFollowersTotalPrevious
                                        ? "up"
                                        : "down"
                                    }`}
                                  >
                                    {artistDetail?.instagramFollowersTotal >
                                    artistDetail?.instagramFollowersTotalPrevious ? (
                                      <FontAwesomeIcon icon={faArrowUp} />
                                    ) : (
                                      <FontAwesomeIcon icon={faArrowDown} />
                                    )}{" "}
                                    {
                                      artistDetail?.instagramFollowersDifPercentage
                                    }{" "}
                                    %
                                  </span>
                                )}
                                {artistDetail?.instagramFollowersDifQuantity !==
                                  null && (
                                  <span className="platform-variation">
                                    {` (${
                                      artistDetail?.instagramFollowersTotal >
                                      artistDetail?.instagramFollowersTotalPrevious
                                        ? "+"
                                        : "-"
                                    } ${
                                      artistDetail?.instagramFollowersDifQuantity
                                    } )`}
                                  </span>
                                )}
                              </div>
                              <div className="artist-profile">
                                <div
                                  className="platform-icon"
                                  onClick={() =>
                                    onClickYoutube(
                                      artist?.artistMetadata?.channelIdYoutube
                                    )
                                  }
                                >
                                  <YoutubeFilled />
                                  <span style={{ color: "#c8c8c8" }}>
                                    Youtube
                                  </span>
                                </div>
                                <span className="platform-number">
                                  {ptBRFormat(
                                    artistDetail?.youtubeFollowersTotal
                                  )}
                                </span>
                                {artistDetail?.youtubeFollowersDifPercentage !==
                                  null && (
                                  <span
                                    className={`weekly-change ${
                                      artistDetail?.youtubeFollowersTotal >
                                      artistDetail?.youtubeFollowersTotalPrevious
                                        ? "up"
                                        : "down"
                                    }`}
                                  >
                                    {artistDetail?.youtubeFollowersTotal >
                                    artistDetail?.youtubeFollowersTotalPrevious ? (
                                      <FontAwesomeIcon icon={faArrowUp} />
                                    ) : (
                                      <FontAwesomeIcon icon={faArrowDown} />
                                    )}{" "}
                                    {
                                      artistDetail?.youtubeFollowersDifPercentage
                                    }{" "}
                                    %
                                  </span>
                                )}
                                {artistDetail?.youtubeFollowersDifQuantity !==
                                  null && (
                                  <span className="platform-variation">
                                    {` (${
                                      artistDetail?.youtubeFollowersTotal >
                                      artistDetail?.youtubeFollowersTotalPrevious
                                        ? "+"
                                        : "-"
                                    } ${
                                      artistDetail?.youtubeFollowersDifQuantity
                                    } )`}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={24}>
                            <div className="card-engagement">
                              <span>
                                <FontAwesomeIcon
                                  icon={faArrowTrendUp}
                                  color="#5DD183"
                                />{" "}
                                {t("pages.ArtistProfile.engagement")}
                              </span>
                              <span>
                                {" "}
                                <FontAwesomeIcon
                                  icon={faUserPlus}
                                  color="#5DD183"
                                />{" "}
                                {t("pages.ArtistProfile.followers")}
                              </span>
                              <span
                                className={`change ${
                                  artistDetail?.engagementDif > 0
                                    ? "up"
                                    : "down"
                                }`}
                              >
                                {artistDetail?.engagementDif > 0 ? (
                                  <FontAwesomeIcon icon={faArrowUp} />
                                ) : (
                                  <FontAwesomeIcon icon={faArrowDown} />
                                )}
                                {` ${Math.abs(artistDetail?.engagementDif)}% `}
                                {artistDetail?.engagementDif < 0
                                  ? t("pages.ArtistProfile.belowAverage")
                                  : t("pages.ArtistProfile.aboveAverage")}
                              </span>
                              <span
                                className={`change ${
                                  artistDetail?.followersDif > 0 ? "up" : "down"
                                }`}
                              >
                                {artistDetail?.followersDif > 0 ? (
                                  <FontAwesomeIcon icon={faArrowUp} />
                                ) : (
                                  <FontAwesomeIcon icon={faArrowDown} />
                                )}
                                {` ${Math.abs(artistDetail?.followersDif)}% `}
                                {artistDetail?.followersDif < 0
                                  ? t("pages.ArtistProfile.belowAverage")
                                  : t("pages.ArtistProfile.aboveAverage")}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
              </Col>
            </Row>
            <Affix>
              <Anchor
                onClick={(e: React.MouseEvent<HTMLElement>) =>
                  e.preventDefault()
                }
                onChange={(link: string) => {
                  setanchorActive(!!link);
                  if (link) setShowFilter(false);
                }}
                targetOffset={65}
              >
                <div style={{ display: anchorActive ? "block" : "none" }}>
                  <AntImage
                    src={artistDetail?.imageProfileUrl}
                    style={{
                      borderRadius: "50%",
                      width: 43,
                      height: 43,
                      objectFit: "cover",
                    }}
                  />
                  <div className="anchor-artist-name">
                    {artist?.artistMetadata?.artistName}
                  </div>
                </div>
                <Link
                  href="#individual-metrics"
                  title={t("pages.ArtistProfile.individualMetric")}
                />
                <Link
                  href="#strm-indexes"
                  title={t("pages.ArtistProfile.strmIndex")}
                />
                <Link
                  href="#catalog-analysis"
                  title={t("pages.ArtistProfile.catalogAnalysis")}
                />
                <Link
                  href="#audio-features"
                  title={t("pages.ArtistProfile.audioFeatures")}
                />
                <BackTop style={{ display: anchorActive ? "block" : "none" }} />
              </Anchor>
            </Affix>
          </div>
        </Col>

        <Col lg={24} xs={24} id="individual-metrics">
          <CardHeader
            header={
              <Row justify="space-between" style={{ padding: 10 }} gutter={5}>
                <Col
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <h1
                    className="title-section"
                    style={{ margin: "0 0 0 32px" }}
                  >
                    {t("pages.ArtistProfile.individualMetric")}
                    <TooltipIndividualMetricsExplains
                      style={{ color: "white", marginLeft: 12 }}
                    />
                  </h1>
                </Col>
                <Col
                  style={{
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    gap: 24,
                  }}
                >
                  <Select
                    placeholder={t("pages.ArtistProfile.selectMetrics")}
                    onChange={onChangeMetric}
                    value={selectedMetric}
                    style={{
                      minWidth: "200px",
                      textAlign: "center",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                    disabled={enableMosaic}
                  >
                    <Select.Option value="performanceIndex">
                      {t("pages.ArtistProfile.performanceIndex")}
                    </Select.Option>
                    <Select.Option value="developmentIndex">
                      {t("pages.ArtistProfile.developmentIndex")}
                    </Select.Option>
                    <Select.Option value="engagementIndex">
                      {t("pages.ArtistProfile.engagementIndex")}
                    </Select.Option>
                    <Select.Option value="followersIndex">
                      {t("pages.ArtistProfile.followersIndex")}
                    </Select.Option>
                    <Select.Option value="performanceSpotify">
                      {t("pages.ArtistProfile.performanceSpotify")}
                    </Select.Option>
                    <Select.Option value="followersCntSpotify">
                      {t("pages.ArtistProfile.followSpotify")}
                    </Select.Option>
                    <Select.Option value="popularitySpotify">
                      {t("pages.ArtistProfile.popularitySpotify")}
                    </Select.Option>
                    <Select.Option value="viewsCntYoutube">
                      {t("pages.ArtistProfile.viewsCountYoutube")}
                    </Select.Option>
                    <Select.Option value="subscribersCntYoutube">
                      {t("pages.ArtistProfile.subscribersCntYoutube")}
                    </Select.Option>
                    <Select.Option value="followersCntInstagram">
                      {t("pages.ArtistProfile.followersCntInstagram")}
                    </Select.Option>
                    <Select.Option value="likesMedianInstagram">
                      {t("pages.ArtistProfile.likesMediamInstagram")}
                    </Select.Option>
                    <Select.Option value="commentsMedianInstagram">
                      {t("pages.ArtistProfile.commentsMedianInstagram")}
                    </Select.Option>
                  </Select>
                  <div>
                    <Radio.Group
                      defaultValue="all"
                      value={filterIndividualMetrics}
                      onChange={onChangeIndividualMetrics}
                    >
                      <Radio.Button value={1}>
                        {t("pages.ArtistProfile.1m")}
                      </Radio.Button>
                      <Radio.Button value={3}>
                        {t("pages.ArtistProfile.3m")}
                      </Radio.Button>
                      <Radio.Button value={6}>
                        {t("pages.ArtistProfile.6m")}
                      </Radio.Button>
                      <Radio.Button value={12}>
                        {t("pages.ArtistProfile.1y")}
                      </Radio.Button>
                      <Radio.Button value="all">
                        {t("pages.ArtistProfile.All")}
                      </Radio.Button>
                    </Radio.Group>
                  </div>

                  <button
                    className={`button-mosaic ${enableMosaic ? "checked" : ""}`}
                    onClick={() => setEnableMosaic(!enableMosaic)}
                  >
                    <MosaicIconWhite />
                  </button>
                </Col>
              </Row>
            }
          >
            {enableMosaic ? (
              <MosaicCharts
                individualMetrics={individualMetrics}
                filterIndividualMetrics={filterIndividualMetrics}
                loading={loadingIndividualMetrics}
              />
            ) : (
              <div style={{ padding: 32 }}>
                <SingleChart
                  individualMetricData={individualMetricData}
                  individualMetricsCategories={individualMetricsCategories}
                  individualMetrics={individualMetrics}
                  selectedMetric={selectedMetric}
                  filterIndividualMetrics={filterIndividualMetrics}
                  loading={loadingIndividualMetrics}
                  color={["#5779FF"]}
                  colorText="#fff"
                />
              </div>
            )}
          </CardHeader>
        </Col>
        <Col lg={24} xs={24} id="strm-indexes">
          <CardHeader
            header={
              <div style={{ padding: "16px 40px" }}>
                <h1 className="title-section" style={{ margin: 0 }}>
                  {t("pages.ArtistProfile.strmIndex")} <TooltipIndexExplains />
                </h1>
              </div>
            }
          >
            <Row>
              <Col lg={24} xs={24} style={{ padding: "24px 40px" }}>
                <ProgressBar
                  strokeWidth={12}
                  format={(value) => `${value} %`}
                  value={(
                    artist?.strmIndexes?.performanceIndex || 0
                  ).toPrecision(3)}
                  color="#37B1E4"
                  trailColor="#131313"
                  title={t("pages.ArtistProfile.performanceChart")}
                  titleClass="texto-maiusculo"
                />
                <ProgressBar
                  strokeWidth={12}
                  format={(value) => `${value} %`}
                  value={(
                    artist?.strmIndexes?.developmentIndex || 0
                  ).toPrecision(3)}
                  color="#EC0190"
                  trailColor="#131313"
                  title={t("pages.ArtistProfile.developmentChart")}
                  titleClass="texto-maiusculo"
                />
                <ProgressBar
                  strokeWidth={12}
                  format={(value) => `${value} %`}
                  value={(
                    artist?.strmIndexes?.performanceSpotify || 0
                  ).toPrecision(3)}
                  color="#5DD183"
                  trailColor="#131313"
                  title={t("pages.ArtistProfile.audioChart")}
                  titleClass="texto-maiusculo"
                />
                <ProgressBar
                  strokeWidth={12}
                  format={(value) => `${value} %`}
                  value={(
                    artist?.strmIndexes?.performanceInstagram || 0
                  ).toPrecision(3)}
                  color="#E4BC5C"
                  trailColor="#131313"
                  title={t("pages.ArtistProfile.imageChart")}
                  titleClass="texto-maiusculo"
                />
                <ProgressBar
                  strokeWidth={12}
                  format={(value) => `${value} %`}
                  value={(
                    artist?.strmIndexes?.volatilityIndex || 0
                  ).toPrecision(3)}
                  color="#F97066"
                  trailColor="#131313"
                  title={t("pages.ArtistProfile.volatilityChart")}
                  titleClass="texto-maiusculo"
                />
              </Col>
            </Row>
          </CardHeader>
        </Col>
        <Col lg={24} xs={24} id="catalog-analysis">
          <Spin
            spinning={loadingRevenueInfo}
            indicator={
              <LoadingOutlined style={{ fontSize: 72 }} spin={false} />
            }
          >
            <div
              style={{
                backgroundColor: "#0D0D0D",
                padding: 32,
                borderRadius: 8,
                marginBottom: 32,
              }}
            >
              <h1
                className="title-section"
                style={{ marginBottom: 16, display: "block" }}
              >
                {t("pages.ArtistProfile.catalogAnalysis")}{" "}
                <Popover
                  content={() => (
                    <div style={{ width: 700 }}>
                      {t("pages.ArtistProfile.disclaimerCatalogAnalysis")}
                    </div>
                  )}
                  placement="right"
                  showArrow={false}
                >
                  <InfoCircleOutlined style={{ color: "#fff" }} />
                </Popover>
              </h1>
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Charts.BarChart
                    {...revenueChart}
                    horizontal={false}
                    cor={[
                      "#2DBDD4",
                      "#AEF4FF",
                      "#005F6E",
                      "#5A57FF",
                      "#A6A5FF",
                      "#33326A",
                    ]}
                    yAxisFormatter={(value: any) =>
                      moneyFormat(value, currency)
                    }
                    showGridX
                    showGridY
                    defaultBarWidth="100%"
                    strokeDashArray={5}
                    height={500}
                    legend={{
                      show: true,
                      fontSize: "18px",
                      position: "bottom",
                      horizontalAlign: "left",
                      fontFamily: "Cabin",
                      itemMargin: { horizontal: 32 },
                      markers: {
                        width: 16,
                        height: 16,
                        radius: 50,
                        offsetX: -2,
                        offsetY: 2,
                      },
                      labels: {
                        colors: "#F2F2F2",
                      },
                    }}
                    stacked
                    borderBarRadius={0}
                    annotations={getForecastChartAnnotations()}
                    forecastDataPointsCount={12}
                  />
                </Col>
                <Col xs={24}>
                  <Row gutter={[32, 32]}>
                    <Col xs={12}>
                      <Row gutter={[18, 18]} style={{ padding: 12 }}>
                        <Col xs={24}>
                          <div className="price-tag">
                            <div className="content">
                              <span
                                style={{ color: "#B8B8B8", display: "block" }}
                              >
                                {t("pages.ArtistProfile.past")}{" "}
                                <Popover
                                  content={() => (
                                    <div>
                                      {t(
                                        "pages.ArtistProfile.estimatedOfCatalogRevenue",
                                        {
                                          month:
                                            revenueForecast?.revenuePastMonths ||
                                            0,
                                        }
                                      )}
                                    </div>
                                  )}
                                  placement="right"
                                  showArrow={false}
                                >
                                  <InfoCircleOutlined
                                    style={{ color: "#fff" }}
                                  />
                                </Popover>
                              </span>
                              <span
                                style={{
                                  fontSize: 34,
                                  fontWeight: 700,
                                  color: "#F2F2F2",
                                }}
                              >
                                {moneyFormat(
                                  revenueForecast?.revenueTotalPast1Y,
                                  currency
                                )}
                                {getTagByTrend(
                                  revenueForecast?.revenueTrendPast1Y,
                                  t
                                )}
                              </span>
                            </div>
                          </div>
                        </Col>
                        <Col xs={24}>
                          <div className="price-tag secondary-blue">
                            <div className="main-content">
                              <h3>{t("pages.ArtistProfile.independente")}:</h3>
                              <span
                                style={{
                                  fontSize: 20,
                                  fontWeight: 700,
                                }}
                              >
                                {moneyFormat(
                                  revenueForecast?.revenueIndependentTotalPast1Y,
                                  currency
                                )}
                              </span>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.royalties")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueIndependentRoyaltiesPast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle secondary-blue-300">
                                  {formatPercentage(
                                    revenueForecast?.revenueIndependentRoyaltiesSharePast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareIn")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueIndependentShareInPast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle secondary-blue-500">
                                  {formatPercentage(
                                    revenueForecast?.revenueIndependentShareInSharePast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareOut")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueIndependentShareOutPast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle secondary-blue-700">
                                  {formatPercentage(
                                    revenueForecast?.revenueIndependentShareOutSharePast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={24}>
                          <div className="price-tag primary-purple">
                            <div className="main-content">
                              <h3>{t("pages.ArtistProfile.major")}: </h3>
                              <span
                                style={{
                                  fontSize: 20,
                                  fontWeight: 700,
                                }}
                              >
                                {moneyFormat(
                                  revenueForecast?.revenueMajorTotalPast1Y,
                                  currency
                                )}
                              </span>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.royalties")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueMajorRoyaltiesPast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle primary-purple-400">
                                  {formatPercentage(
                                    revenueForecast?.revenueMajorRoyaltiesSharePast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareIn")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueMajorShareInPast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle primary-purple-500">
                                  {formatPercentage(
                                    revenueForecast?.revenueMajorShareInSharePast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareOut")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueMajorShareOutPast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle primary-purple-800">
                                  {formatPercentage(
                                    revenueForecast?.revenueMajorShareOutSharePast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12}>
                      <Row gutter={[18, 18]} style={{ padding: 12 }}>
                        <Col xs={24}>
                          <div className="price-tag">
                            <div className="content">
                              <span
                                style={{ color: "#B8B8B8", display: "block" }}
                              >
                                {t("pages.ArtistProfile.future")}{" "}
                                <Popover
                                  content={() => (
                                    <div>
                                      {t(
                                        "pages.ArtistProfile.projectionOfCatalogRevenue"
                                      )}
                                    </div>
                                  )}
                                  placement="right"
                                  showArrow={false}
                                >
                                  <InfoCircleOutlined
                                    style={{ color: "#fff" }}
                                  />
                                </Popover>
                              </span>
                              <span
                                style={{
                                  fontSize: 34,
                                  fontWeight: 700,
                                  color: "#F2F2F2",
                                }}
                              >
                                {moneyFormat(
                                  revenueForecast?.revenueTotalForecast1Y,
                                  currency
                                )}
                                {getTagByTrend(
                                  revenueForecast?.revenueTrendForecast1Y,
                                  t
                                )}
                              </span>
                            </div>
                          </div>
                        </Col>
                        <Col xs={24}>
                          <div className="price-tag secondary-blue">
                            <div className="main-content">
                              <h3>{t("pages.ArtistProfile.independente")}:</h3>
                              <span
                                style={{
                                  fontSize: 20,
                                  fontWeight: 700,
                                }}
                              >
                                {moneyFormat(
                                  revenueForecast?.revenueIndependentTotalForecast1Y,
                                  currency
                                )}
                              </span>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.royalties")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueIndependentRoyaltiesForecast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle secondary-blue-300">
                                  {formatPercentage(
                                    revenueForecast?.revenueIndependentRoyaltiesShareForecast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareIn")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueIndependentShareInForecast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle secondary-blue-500">
                                  {formatPercentage(
                                    revenueForecast?.revenueIndependentShareInShareForecast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareOut")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueIndependentShareOutForecast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle secondary-blue-700">
                                  {formatPercentage(
                                    revenueForecast?.revenueIndependentShareOutShareForecast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={24}>
                          <div className="price-tag primary-purple">
                            <div className="main-content">
                              <h3>{t("pages.ArtistProfile.major")}: </h3>
                              <span
                                style={{
                                  fontSize: 20,
                                  fontWeight: 700,
                                }}
                              >
                                {moneyFormat(
                                  revenueForecast?.revenueMajorTotalForecast1Y,
                                  currency
                                )}
                              </span>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.royalties")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueMajorRoyaltiesForecast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle primary-purple-400">
                                  {formatPercentage(
                                    revenueForecast?.revenueMajorRoyaltiesShareForecast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareIn")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueMajorShareInForecast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle primary-purple-500">
                                  {formatPercentage(
                                    revenueForecast?.revenueMajorShareInShareForecast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="renenue-box">
                              <div className="content">
                                <h4>{t("pages.ArtistProfile.shareOut")}</h4>
                                <span
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                  }}
                                >
                                  {moneyFormat(
                                    revenueForecast?.revenueMajorShareOutForecast1Y,
                                    currency
                                  )}
                                </span>
                                <span className="circle primary-purple-800">
                                  {formatPercentage(
                                    revenueForecast?.revenueMajorShareOutShareForecast1Y
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xs={24}>
                  <CardHeader>
                    <CollapseTable
                      title="Royalties"
                      nestedData="royalties"
                      phonogramType="Royalties"
                      artistId={selectedArtist.artistIdStrm}
                      dataSource={revenueForecast?.phonogramsRoyalties || []}
                      currency={currency}
                      percentage={
                        revenueForecast?.phonogramsConcentrationRoyalties
                      }
                    />
                  </CardHeader>
                </Col>
                <Col xs={24}>
                  <CardHeader>
                    <CollapseTable
                      title="Share-in"
                      nestedData="shareIn"
                      phonogramType="ShareIn"
                      artistId={selectedArtist.artistIdStrm}
                      dataSource={revenueForecast?.phonogramsShareIn || []}
                      currency={currency}
                      percentage={
                        revenueForecast?.phonogramsConcentrationShareIn
                      }
                    />
                  </CardHeader>
                </Col>
                <Col xs={24}>
                  <CardHeader>
                    <CollapseTable
                      title="Share-out"
                      nestedData="shareOut"
                      phonogramType="ShareOut"
                      artistId={selectedArtist.artistIdStrm}
                      dataSource={revenueForecast?.phonogramsShareOut || []}
                      currency={currency}
                      percentage={
                        revenueForecast?.phonogramsConcentrationShareOut
                      }
                    />
                  </CardHeader>
                </Col>
              </Row>
            </div>
          </Spin>
          <Row gutter={[32, 32]}>
            <Col xs={24}>
              <CardHeader
                header={
                  <div style={{ padding: 16 }}>
                    <Typography.Text>
                      {t("pages.ArtistProfile.releasesSingleEpAlbun")}
                    </Typography.Text>
                  </div>
                }
              >
                <div style={{ padding: 16, color: "#fff" }}>
                  <Row>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.firstRelease")}</label>
                        <span>{firstRelease}</span>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.lastRelease")}</label>
                        <span>{latestRelease}</span>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.singles")}</label>
                        <span>{artistDetail?.totalSingles}</span>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.albuns")}</label>
                        <span>{artistDetail?.totalAlbuns}</span>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.totalReleases")}</label>
                        <span>{artistDetail?.totalReleases}</span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardHeader>
            </Col>
            <Col xs={24}>
              <CardHeader
                header={
                  <div style={{ padding: 16 }}>
                    <Typography.Text>
                      {t("pages.ArtistProfile.featTracks")}
                    </Typography.Text>
                  </div>
                }
              >
                <div style={{ padding: 16, color: "#fff" }}>
                  <Row>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.leading")}</label>
                        <span>{artistDetail?.protagonistCollab}</span>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.guest")}</label>
                        <span>{artistDetail?.invitedCollab}</span>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="catalog-info">
                        <label>{t("pages.ArtistProfile.total")}</label>
                        <span>{artistDetail?.totalCollab}</span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardHeader>
            </Col>
            <Col xs={6}>
              <CardHeader>
                <div className="info-card">
                  <div className="info">
                    <span>
                      {t("pages.ArtistProfile.lastTwelveMonths")}{" "}
                      <Popover
                        content={() => (
                          <div style={{ width: 700 }}>
                            {t(
                              "pages.ArtistProfile.disclaimerTwelveMonthsRelease"
                            )}
                          </div>
                        )}
                        placement="right"
                        showArrow={false}
                      >
                        <InfoCircleOutlined
                          style={{ color: "#fff", marginLeft: 6 }}
                        />
                      </Popover>
                    </span>

                    <span className="value">
                      {t("pages.ArtistProfile.releasesCount", {
                        releases: artistDetail?.releasesLast12MonthsTotal,
                      })}
                    </span>
                    <div className="variation">
                      <span
                        className={`weekly-change ${
                          !artistDetail?.releaseLast12MonthsIsUnderAverage
                            ? "up"
                            : "down"
                        }`}
                      >
                        {!artistDetail?.releaseLast12MonthsIsUnderAverage ? (
                          <FontAwesomeIcon icon={faArrowUp} />
                        ) : (
                          <FontAwesomeIcon icon={faArrowDown} />
                        )}{" "}
                        {Math.abs(artistDetail?.releaseLast12MonthsPercentage)}{" "}
                        %
                      </span>
                      <span>
                        {artistDetail?.releaseLast12MonthsIsUnderAverage
                          ? t("pages.ArtistProfile.belowAverage")
                          : t("pages.ArtistProfile.aboveAverage")}
                      </span>
                    </div>
                  </div>
                  <div className="icon">
                    <RocketIcon />
                  </div>
                </div>
              </CardHeader>
            </Col>
            <Col xs={6}>
              <CardHeader>
                <div className="info-card">
                  <div className="info">
                    <span>
                      {t("pages.ArtistProfile.releaseFrequency")}
                      <Popover
                        content={() => (
                          <div style={{ width: 700 }}>
                            {t(
                              "pages.ArtistProfile.disclaimerReleaseFrequency"
                            )}
                          </div>
                        )}
                        placement="right"
                        showArrow={false}
                      >
                        <InfoCircleOutlined
                          style={{ color: "#fff", marginLeft: 6 }}
                        />
                      </Popover>
                    </span>
                    <span className="value">
                      <Trans
                        i18nKey="pages.ArtistProfile.releaseFrequencyText"
                        ns="radar"
                        values={{ daysOfRelease }}
                      />
                    </span>
                    <div className="variation">
                      <span
                        className={`weekly-change ${
                          isUnderAverage ? "down" : "up"
                        }`}
                      >
                        {isUnderAverage ? (
                          <FontAwesomeIcon icon={faArrowDown} />
                        ) : (
                          <FontAwesomeIcon icon={faArrowUp} />
                        )}{" "}
                        {percentageOfRelease}
                      </span>
                      <span> {average}</span>
                    </div>
                  </div>
                  <div className="icon">
                    <RocketIcon />
                  </div>
                </div>
              </CardHeader>
            </Col>
            <Col xs={6}>
              <CardHeader>
                <div className="info-card">
                  <div className="info">
                    <span>
                      {t("pages.ArtistProfile.popularity")}{" "}
                      <Popover
                        content={() =>
                          t(
                            "pages.CareerDiagnose.popularityFeatVsSoloDisclaimer"
                          )
                        }
                        placement="right"
                        showArrow={false}
                      >
                        <InfoCircleOutlined
                          style={{ color: "#fff", marginLeft: 6 }}
                        />
                      </Popover>
                    </span>
                    <span className="value">
                      <Trans
                        i18nKey="pages.ArtistProfile.feat"
                        ns="radar"
                        values={{
                          feat:
                            artistDetail?.popularityFeat !== null
                              ? artistDetail?.popularityFeat
                              : "-",
                        }}
                      />
                      {` VS `}
                      <Trans
                        i18nKey="pages.ArtistProfile.solo"
                        ns="radar"
                        values={{
                          solo:
                            artistDetail?.popularitySolo !== null
                              ? artistDetail?.popularitySolo
                              : "-",
                        }}
                      />
                    </span>
                    <div className="variation">
                      <span className="weekly-change no-change">
                        {artistDetail?.percentageBetweenPopularityFeatAndPopularitySolo.toPrecision(
                          3
                        )}{" "}
                        %
                      </span>
                      <span>
                        {t("pages.ArtistProfile.percentageDifference")}
                      </span>
                    </div>
                  </div>
                  <div className="icon">
                    <FollowersIcon
                      style={{
                        transform: "matrix(0.98, -0.17, 0.2, 0.98, 0, 0)",
                      }}
                    />
                  </div>
                </div>
              </CardHeader>
            </Col>
            <Col xs={6}>
              <CardHeader>
                <div className="info-card">
                  <div className="info">
                    <span>
                      {t("pages.ArtistProfile.popularity")}{" "}
                      <Popover
                        content={() =>
                          t(
                            "pages.CareerDiagnose.popularitySingleVsAlbumDisclaimer"
                          )
                        }
                        placement="right"
                        showArrow={false}
                      >
                        <InfoCircleOutlined
                          style={{ color: "#fff", marginLeft: 6 }}
                        />
                      </Popover>
                    </span>
                    <span className="value">
                      <Trans
                        i18nKey="pages.ArtistProfile.single"
                        ns="radar"
                        values={{
                          single:
                            artistDetail?.popularitySingle !== null
                              ? artistDetail?.popularitySingle
                              : "-",
                        }}
                      />
                      {` VS `}
                      <Trans
                        i18nKey="pages.ArtistProfile.album"
                        ns="radar"
                        values={{
                          album:
                            artistDetail?.popularityAlbum !== null
                              ? artistDetail?.popularityAlbum
                              : "-",
                        }}
                      />
                    </span>
                    <div className="variation">
                      <span className="weekly-change no-change">
                        {artistDetail?.percentageBetweenPopularitySingleAndPopularityAlbum.toPrecision(
                          3
                        )}{" "}
                        %
                      </span>
                      <span>
                        {t("pages.ArtistProfile.percentageDifference")}
                      </span>
                    </div>
                  </div>
                  <div className="icon">
                    <FollowersIcon
                      style={{
                        transform: "matrix(0.98, -0.17, 0.2, 0.98, 0, 0)",
                      }}
                    />
                  </div>
                </div>
              </CardHeader>
            </Col>
          </Row>

          <CardHeader
            header={
              <div style={{ padding: 12, marginTop: 60 }}>
                <Row justify="end">
                  <Col
                    xs={24}
                    style={{
                      display: "flex",
                      gap: 12,
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <Select
                      onChange={onChangeTrend}
                      value={selectedTrend}
                      style={{ minWidth: 310, marginLeft: 24 }}
                    >
                      <Select.Option value="releaseTrend">
                        {t("pages.ArtistProfile.releaseTrend")}
                      </Select.Option>
                      <Select.Option value="trackTrend">
                        {t("pages.ArtistProfile.trackTrend")}
                      </Select.Option>
                      <Select.Option value="trackPopularityHistory">
                        {t("pages.ArtistProfile.trackPopularityHistory")}
                      </Select.Option>
                    </Select>
                    <Popover
                      content={() => (
                        <div style={{ width: 700 }}>
                          {selectedTrend === "trackPopularityHistory"
                            ? t(
                                "pages.ArtistProfile.disclaimerTrackPopularityHistoryTooltip"
                              )
                            : selectedTrend === "trackTrend"
                            ? t("pages.ArtistProfile.disclaimerTrackPopularity")
                            : t(
                                "pages.ArtistProfile.disclaimerReleasePopularity"
                              )}
                        </div>
                      )}
                      placement="right"
                      showArrow={false}
                    >
                      <InfoCircleOutlined style={{ color: "#fff" }} />
                    </Popover>
                  </Col>
                </Row>
              </div>
            }
          >
            <div>
              {selectedTrend === "releaseTrend" && (
                <>
                  <Charts.ScatterChart
                    {...artistReleaseTrend}
                    tooltip={{
                      points: artistReleaseTrend.scatterData,
                      title: t("pages.ArtistProfile.release"),
                      name: t("pages.ArtistProfile.name"),
                      release: t("pages.ArtistProfile.releaseDate"),
                      ageInMonths: t("pages.ArtistProfile.ageInMonths"),
                      popularity: t("pages.ArtistProfile.popularity"),
                      type: `${t("pages.ArtistProfile.releaseType")}`,
                    }}
                    yAxisLabelText={t("pages.ArtistProfile.popularity")}
                    xAxisLabelText={t("pages.ArtistProfile.releaseAgeInMonths")}
                    customLegendItems={[
                      t("pages.ArtistProfile.releaseTrendLegend"),
                    ]}
                    containerHeight={500}
                  />
                  <Table
                    columns={colunas("release")}
                    dataSource={lastReleases}
                    rowKey="id"
                    loading={loadingIndividualMetrics}
                    pagination={{
                      defaultPageSize: 5,
                      showQuickJumper: false,
                      showPrevNextJumpers: false,
                    }}
                    key="artist-release-table"
                  />
                </>
              )}
              {selectedTrend === "trackTrend" && (
                <>
                  <Charts.ScatterChart
                    {...artistTrackTrend}
                    tooltip={{
                      points: artistTrackTrend.scatterData,
                      title: t("pages.ArtistProfile.track"),
                      name: t("pages.ArtistProfile.name"),
                      release: t("pages.ArtistProfile.releaseDate"),
                      ageInMonths: t("pages.ArtistProfile.ageInMonths"),
                      popularity: t("pages.ArtistProfile.popularity"),
                      type: `${t("pages.ArtistProfile.releaseType")}`,
                    }}
                    yAxisLabelText={t("pages.ArtistProfile.popularity")}
                    xAxisLabelText={t("pages.ArtistProfile.trackAgeInMonths")}
                    containerHeight={470}
                    showLegend={false}
                    handlerSeriesFillColor={(data: any) =>
                      data.isSolo ? "#3791e3" : "#EC0190"
                    }
                  />
                  <div
                    className="apexcharts-legend apexcharts-align-left apx-legend-position-bottom"
                    style={{ marginBottom: 16, display: "flex", gap: 8 }}
                  >
                    <div className="apexcharts-legend-series">
                      <span
                        className="apexcharts-legend-marker"
                        style={{
                          background: "#3791e3",
                          height: 12,
                          width: 12,
                          borderWidth: 0,
                          borderRadius: 12,
                        }}
                      ></span>
                      <span
                        className="apexcharts-legend-text"
                        style={{
                          color: "#fff",
                          fontSize: 12,
                        }}
                      >
                        {t("pages.ArtistProfile.trackTrendLgend")}
                      </span>
                    </div>
                    <div className="apexcharts-legend-series">
                      <span
                        className="apexcharts-legend-marker"
                        style={{
                          background: "#EC0190",
                          height: 12,
                          width: 12,
                          borderWidth: 0,
                          borderRadius: 12,
                        }}
                      ></span>
                      <span
                        className="apexcharts-legend-text"
                        style={{
                          color: "#fff",
                          fontSize: 12,
                        }}
                      >
                        {t("pages.ArtistProfile.trackTrendFeat")}
                      </span>
                    </div>
                  </div>
                  <Table
                    columns={colunas()}
                    dataSource={artistTracks.filter((x: any) => !x.isFeatGuest)}
                    rowKey="id"
                    loading={loadingIndividualMetrics}
                    pagination={{
                      defaultPageSize: 5,
                      showQuickJumper: false,
                      showPrevNextJumpers: false,
                    }}
                    key="artist-track-table"
                  />
                </>
              )}
              {selectedTrend === "trackPopularityHistory" && (
                <>
                  <Charts.LineChart
                    {...tracksPopularityHistory}
                    color={historyTrackColors.map((color) => color.color)}
                    xaxisLabelFormat="dd/MM/yy"
                    xaxisType="datetime"
                    xLabelFormatter={(val) => moment(val).format("DD/MM/YYYY")}
                    animation={false}
                    height={500}
                  />
                  <Table
                    columns={colunas()}
                    rowSelection={rowSelection}
                    dataSource={artistTracks.filter((x: any) => !x.isFeatGuest)}
                    rowKey={(row: any) => row.trackIdSpotify}
                    loading={loadingIndividualMetrics}
                    pagination={{
                      defaultPageSize: 7,
                      showQuickJumper: false,
                      showPrevNextJumpers: false,
                    }}
                    key="artist-track-popularity-history-table"
                  />
                </>
              )}
            </div>
          </CardHeader>
        </Col>
        <Col lg={24} xs={24} id="audio-features">
          <CardHeader
            header={
              <div style={{ padding: 24 }}>
                <Typography.Text>
                  {t("pages.ArtistProfile.audioFeatures")}
                </Typography.Text>
              </div>
            }
          >
            <div style={{ padding: 24 }} className="audio-features">
              <p className="subtitle-audio-features">
                {t("pages.ArtistProfile.audioFeaturesExplanation")}
              </p>
              <Charts.RadarChart
                cor={["#5779FF", "#EC0190", "#E4BC5C", "#FD6F8E"]}
                tooltip={
                  audioFeatures?.categories.map((serie: any) => ({
                    text: t(`pages.ArtistProfile.${serie}`),
                    name: serie,
                    bpm: artist?.audioFeatures?.bpm,
                  })) || []
                }
                textColor="#E6E6E6"
                polygonProps={{
                  strokeColors: "#4F4E59",
                  connectorColors: "#4F4E59",
                  strokeWidth: "1px",
                  fillColors: ["#2d2c30", "#212023"],
                }}
                legendStyle={{
                  horizontalAlign: "left",
                }}
                multiplyBy100
                strokeWidth={0}
                markerSize={9}
                height={650}
                useI18nLabel={false}
                {...audioFeatures}
              />
            </div>
          </CardHeader>
        </Col>
      </Row>
    </div>
  );
};

export default ArtistProfile;
